import type { BroadcastLayout } from "../../lib/broadcastApi";

/** A layout message older than the one on screen is stale and ignored. */
export function shouldApplyLayout(
  current: Pick<BroadcastLayout, "version"> | null | undefined,
  incoming: Pick<BroadcastLayout, "version"> | null | undefined,
): boolean {
  if (!incoming || typeof incoming.version !== "number") return false;
  if (!current) return true;
  return incoming.version >= current.version;
}

/**
 * Session-wide ordering (EPIC-109): a message whose `layout_seq` is lower than
 * or equal to the last applied one is stale (every write increments it). A Take always increments the counter, so
 * it is never dropped just because its scene was edited long ago.
 */
export function shouldApplySeq(
  currentSeq: number | null | undefined,
  incomingSeq: number,
): boolean {
  return currentSeq == null || incomingSeq > currentSeq;
}
